import { apiClient } from '../api';
import { debounce } from 'ts-debounce';

export class Shop {
  constructor() {
    const buyRow = document.querySelector<HTMLElement>('.shop .row-buy');
    if (!buyRow) {
      return;
    }

    const plusBtn = buyRow.querySelector<HTMLElement>('.quantity > .plus');
    const minusBtn = buyRow.querySelector<HTMLElement>('.quantity > .minus');
    const qtyField = buyRow.querySelector<HTMLInputElement>('#product-field-qty');

    if (plusBtn && minusBtn && qtyField) {
      plusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        qtyField.stepUp();
      });

      minusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        qtyField.stepDown();
      });
    }

    const discountField = buyRow.querySelector<HTMLInputElement>('#product-field-promo');
    discountField?.addEventListener('input', () => this.checkDiscount(discountField));
  }

  checkDiscount(field: HTMLInputElement) {
    const check = debounce(() => {
      const productId = field.getAttribute('data-product-id');
      const code = field.value;
      if (!productId || !code) {
        return;
      }

      apiClient
        .get(`/api/discounts/product/${productId}/${code}`)
        .then(response => {
          if (response && response.data && response.data.valid) {
            field.classList.remove('is-invalid');
            field.classList.add('is-valid');
          } else {
            field.classList.add('is-invalid');
            field.classList.remove('is-valid');
          }
        });
    }, 1000);

    check();
  }
}

function init() {
  new Shop();
}

window.addEventListener('load', init, false);
